import { AppContext } from "@ctsu/loader";
import { IconClose, IconSyncAlt } from "components/common/Icons";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { usePathName } from "helpers/utils";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { saveInstitutionJobId } from "stores/redux/actions";
import { affiliationsJobUrl } from "stores/redux/actions/constants";

const DEFAULT_STATUS = "PROCESSING";

export function AutoHide({ children, callback }) {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const id = setTimeout(() => {
      setVisible(false);
      callback();
    }, [60000]);
    return () => clearTimeout(id);
  });
  return visible ? <>{children}</> : null;
}
export default function CheckJobStatus() {
  const [status, setStatus] = useState(null);
  const [delay, setDelay] = useState(2000);
  const ctepIdRef = useRef(null);
  let job = useSelector(state => state?.institutionJobId?.data);
  const context = useContext(AppContext);
  const pathname = usePathName();
  const { session } = context;
  if (session && !job) {
    const jobFromSession = session?.userData?.job;
    try {
      if (JSON.parse(jobFromSession)) {
        job = JSON.parse(jobFromSession);
      }
    } catch (e) {
      console.log("JSON parse issue");
    }
  }
  const pendingJobId = job?.id;
  const message = job?.message;
  const ctepId = job?.ctepId;
  const dispatch = useDispatch();
  useEffect(() => {
    let id;
    function checkStatus() {
      makeAjaxRequest
        .fetchWithAuth(`${affiliationsJobUrl}/${pendingJobId}/status`)
        .then(response => {
          if (response.status === "FAILED") {
            clearInterval(id);
            setStatus(response.status);
            dispatch(saveInstitutionJobId({}));
            ctepIdRef.current = ctepId;
          } else if (response.status === "COMPLETE") {
            clearInterval(id);
            dispatch(saveInstitutionJobId({}));
            if (pathname?.indexOf("/institution/roster/affiliation") > -1) {
              const refreshEvent = new CustomEvent("refresh", {
                bubbles: true,
                cancelable: true
              });
              document.dispatchEvent(refreshEvent);
            }
            ctepIdRef.current = ctepId;
            setStatus(response.status);
          } else if (delay < 60000) {
            clearInterval(id);
            setDelay(delay + 15000);
          }
        })
        .catch(() => {
          clearInterval(id);
          dispatch(saveInstitutionJobId({}));
          setStatus("FAILED");
        });
    }

    if (pendingJobId) {
      if (status !== DEFAULT_STATUS) {
        setStatus(DEFAULT_STATUS);
      }
      id = setInterval(() => checkStatus(), delay);
    }
    return () => clearInterval(id);
  }, [pendingJobId, dispatch, delay, ctepId, pathname, status]);

  const CloseButton = () => (
    <button
      title="close"
      type="button"
      className="color-red float-right fn-btn"
      onClick={() => setStatus(null)}
    >
      <IconClose />
    </button>
  );
  if (status === "COMPLETE") {
    return (
      <AutoHide callback={() => setStatus(null)}>
        <div aria-live="polite" className="align-center color-blue-darker bg-blue-lighter p-1 shadow-sm">
          Your request for {ctepIdRef.current} is complete.
          <CloseButton />
        </div>
      </AutoHide>
    );
  }
  if (status === "FAILED") {
    return (
      <AutoHide callback={() => setStatus(null)}>
        <div aria-live="polite" className="align-center color-blue-darker bg-blue-lighter p-1 shadow-sm">
          Your request for {ctepIdRef.current} failed. Please try again or contact ctsucontact@westat.com.
          <CloseButton />
        </div>
      </AutoHide>
    );
  }
  if (status === DEFAULT_STATUS) {
    return (
      <div
        data-testid="affilation-job-pending"
        data-status={status}
        className="align-center color-blue-darker bg-blue-lighter p-1 shadow-sm"
        aria-live="polite"
      >
        <IconSyncAlt />
        {message}
      </div>
    );
  }

  return null;
}
